import React from 'react';
import { Spin } from 'antd';

const Spinner = ({ loading }) => {
    if (!loading) {
        return null;
    }

    return (
        <div style={{textAlign:'center'}}>
            <Spin size="large" />
        </div>
    )
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.js